import React, { useState, useEffect, useContext } from "react";
import CustomFilters from "../../../../core/custom-filters";
import { HTTP_METHODS, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiTextField from "../../../../core/si-textfield";
import AppContext from "../../../../utils/context";
import { PAGE_LIMIT } from "../../../../utils";

const BenchFilters = ({ loadData }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [oemList, setOemList] = useState([]);
  let oemTimeout = null;

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }

      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
      });
    } else {
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = () => {
    const filtersArr = [
      { label: "Filter by Oem", value: "oem" },
      { label: "Filter by Engine Serial Number", value: "engineSerialNumber" },
      {
        label: "Filter by Machine Serial Number",
        value: "machineSerialNumber",
      },
      {
        label: "Filter by Machine Model",
        value: "machineModel",
      },
      {
        label: "Filter by Engine Model",
        value: "engineModel",
      },
    ];

    return filtersArr;
  };

  const renderFilterInput = () => {
    switch (filterType) {
      case "machineModel":
        return (
          <SiTextField
            placeholder="Machine Model"
            name="machineModel"
            onChange={handleFilterValueChange}
          />
        );
      case "oem":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemList}
            placeholder="Search OEM"
            onInputChange={(newInputValue) => handleRegexSearch(newInputValue)}
          />
        );
      case "engineModel":
        return (
          <SiTextField
            placeholder="Engine Model"
            name="engineModel"
            onChange={handleFilterValueChange}
          />
        );
      case "engineSerialNumber":
        return (
          <SiTextField
            placeholder="Engine Serial Number"
            name="engineSerialNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "machineSerialNumber":
        return (
          <SiTextField
            placeholder="Machine Serial Number"
            name="machineSerialNumber"
            onChange={handleFilterValueChange}
          />
        );

      default:
        return null;
    }
  };
  const getOemList = (inputValue) => {
    const params = inputValue ? { name: inputValue } : {};
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_ADMIN_OEMS}`,
      null,
      params
    )
      .then((response) => {
        if (Array.isArray(response) && response) {
          let oems = response.map((r) => {
            return {
              ...r,
              label: `${r.code}-${r.name}`,
              value: r.id,
            };
          });

          setOemList(oems);
        }
      })
      .catch((err) => console.error(err));
  };
  const handleRegexSearch = (newInputValue) => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue), 300);
    }
  };
  useEffect(() => {
    getOemList();
  }, [filterType]);
  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes()}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default BenchFilters;
